import type { GraphPathLookupParameters } from '../api/GraphPathLookupParameters';
import type { PathLookupGraphSettings } from '../graphSettings';
import type { PathLookupIpProtocol, PathLookupTcpFlag } from './PacketHeader';

export const pathLookupExpectedPassingTraffic = ['all', 'none'] as const;
export type PathLookupExpectedPassingTraffic =
  (typeof pathLookupExpectedPassingTraffic)[number];
export const pathLookupPassingTraffic = [
  'all',
  'error',
  'none',
  'part',
] as const;
export type PathLookupPassingTraffic =
  (typeof pathLookupPassingTraffic)[number];
export type PathLookupCheckId = string;

export interface PathLookupCheckExistence {
  exists: boolean;
  expectedPassingTraffic?: PathLookupPassingTraffic;
}

export function scoreToPathLookupPassingTraffic(
  passing: number,
  total: number,
): PathLookupPassingTraffic {
  if (passing === total) {
    return 'all';
  }
  if (passing === 0) {
    return 'none';
  }
  return 'part';
}

export const pathLookupTypes = [
  'multicast',
  'unicast',
  'hostToDefaultGW',
] as const;
export type PathLookupType = (typeof pathLookupTypes)[number];

export interface PathLookupCheck {
  id: PathLookupCheckId;
  dst: string;
  dstPorts: string | null;
  errors: string[];
  expectedPassingTraffic: PathLookupExpectedPassingTraffic;
  flags: PathLookupTcpFlag[];
  networkMode?: boolean;
  passingTraffic: PathLookupPassingTraffic | null;
  parameters: GraphPathLookupParameters;
  protocol: PathLookupIpProtocol;
  receiver: string;
  result: string[];
  securedPath: boolean;
  settings: PathLookupGraphSettings;
  src: string;
  srcPorts: string | null;
  type: PathLookupType;
  vrf: string | null;
}
